import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage.jsx';
import LandingPage from './pages/LandingPage.jsx';
import HistoryPage from './pages/HistoryPage.jsx';
import AdminPage from './pages/AdminPage.jsx';
import MaintenancePage from './pages/MaintenancePage.jsx';
import { useBootstrap } from './context/BootstrapContext.jsx';
import { useLucideIcons, usePageStyles } from './hooks/usePageAssets.js';
import { resolveStaticUrl } from './utils/staticAssets.js';

const AdminRoute = () => {
  const bootstrap = useBootstrap();

  if (!bootstrap?.ready) {
    return (
      <div className="page-loading">
        <p>Validando permisos del panel...</p>
      </div>
    );
  }

  if (!bootstrap?.authenticated) {
    return <Navigate to="/landing" replace />;
  }

  if (!bootstrap?.is_super_admin) {
    return <Navigate to="/" replace />;
  }

  return <AdminPage />;
};

const SuperAdminMaintenanceBanner = () => {
  usePageStyles([resolveStaticUrl('css/maintenance.css')]);
  useLucideIcons([]);
  return (
    <a className="superadmin-maintenance-banner" href="/admin" aria-label="Abrir configuración de mantenimiento">
      <i data-lucide="construction" />
      <span><strong>Modo de mantenimiento activo</strong> · Tu acceso de super administrador permanece habilitado.</span>
      <i data-lucide="arrow-right" />
    </a>
  );
};

const AppContent = () => {
  const bootstrap = useBootstrap();
  const maintenanceEnabled = Boolean(bootstrap?.maintenance_mode?.enabled);
  const superAdmin = Boolean(bootstrap?.is_super_admin);

  if (maintenanceEnabled && !superAdmin) {
    return <MaintenancePage />;
  }

  return (
    <>
      {maintenanceEnabled && superAdmin ? <SuperAdminMaintenanceBanner /> : null}
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/welcome" element={<Navigate to="/landing" replace />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/admin" element={<AdminRoute />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

const App = () => (
  <BrowserRouter>
    <AppContent />
  </BrowserRouter>
);

export default App;
